import React,{Component} from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col
} from 'reactstrap';

import find from 'lodash/find';

import ProgressBarSVG from '../../../shared/components/ProgressBarSVG';

import { countsToRoundedPercents } from '../../../shared/utils';

class ChooseResults extends Component {
  getVotesForOptionWithId(id){
    const optionKPI = find(this.props.engagementKPIs.answerKPIs, (a) => a.answer === id);

    return optionKPI ? optionKPI.answersNum : 0;
  }

  getWinningOption(){
    const answerKPIs = this.props.engagementKPIs.answerKPIs;

    return answerKPIs.reduce((win,a) => a.answersNum > win.answersNum ? a : win, answerKPIs[0]);
  }

  getSortedOptions(){
    return this.props.engagement.options.sort((a,b) => a.createdDate - b.createdDate);
  }

  render(){
    const {engagement} = this.props,
      winningOption = this.getWinningOption();

    const voteCounts = this.getSortedOptions().map((a) => this.getVotesForOptionWithId(a.id)),
      totalVotes = voteCounts.reduce((total,count) => total + count),
      roundedPercents = countsToRoundedPercents(voteCounts); 

    return (
      <div className='EngagementResults'>
        <Row style={{pageBreakInside:'avoid'}}>
          <Col xs='4'>
            <br />
            <br />
            <h6>Multiple Choice</h6>
            <img
              src={engagement.firstImageURL}
              style={{maxWidth:200,borderRadius:10}}
              alt='Activity imagery'
            />
          </Col>
          <Col xs='8'>
            <br />
            <br />
            <br />
            {engagement.text}
            <br />
            <br />
            {this.getSortedOptions().map((o,i) => {
              return (
                <ProgressBarSVG
                  key={i}
                  title={o.answer}
                  votes={voteCounts[i]}
                  totalVotes={totalVotes}
                  displayPercent={roundedPercents[i]}
                  winner={winningOption && winningOption.answer === o.id}
                />
              );
            })}
          </Col>
        </Row>
        <Row>
          <Col xs='12'>
            <br />
            <br />
          </Col>
        </Row>
      </div>
    )
  }
}

ChooseResults.propTypes = {
  engagement:PropTypes.object.isRequired,
  engagementKPIs:PropTypes.object.isRequired
};

export default ChooseResults;



// WEBPACK FOOTER //
// ./src/routes/CampaignResultsPrint/components/ChooseResults.js